import { render, staticRenderFns } from "./Immo.vue?vue&type=template&id=6bbe7239"
import script from "./Immo.vue?vue&type=script&lang=js"
export * from "./Immo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports